import { PromoUrlType } from 'shared/api/avia/main-page'

import type { PromoPage as Page } from '../model'

export const hasPromoAction = (promo: Page | null): boolean => {
  if (!promo) return false

  switch (promo.url_type) {
    case PromoUrlType.EXTERNAL:
    case PromoUrlType.INTERNAL:
    case PromoUrlType.MBANK_DEEPLINK:
      return Boolean(promo.redirect_url)
    case PromoUrlType.PDF:
      return Boolean(promo.file)
    default:
      return false
  }
}
